import configs from './config';

const env = process.env.REACT_APP_ENV || 'development';
const { baseURL, uploadImageBaseURL } = configs[env];

export { baseURL, uploadImageBaseURL };
